export default "__VITE_ASSET__DoDtbwYB__"